import React from 'react';

import { SpecCourseLessonViewSectionContent } from 'common.components/spec-course-lesson-view/__section-content/spec-course-lesson-view__section-content';
import { SpecCourseLessonViewSectionDescription } from 'common.components/spec-course-lesson-view/__section-description/spec-course-lesson-view__section-description';
import { SpecCourseLessonViewSection } from 'common.components/spec-course-lesson-view/__section/spec-course-lesson-view__section';

import { SpecCourseResultsTitle } from '../__title/results__title';
import { SpecCourseLessonViewStubNoStudents } from '../../spec-course.lesson-view/__stub/lesson-view__stub_no-students';

export const SpecCourseResultsNoStudentsStub = () => {
    return (
        <SpecCourseLessonViewSection>
            <SpecCourseResultsTitle />
            <SpecCourseLessonViewSectionDescription id="specCourse.lessonView.resultsTable.resultsAreNotAvailable.description" />
            <SpecCourseLessonViewSectionContent>
                <SpecCourseLessonViewStubNoStudents />
            </SpecCourseLessonViewSectionContent>
        </SpecCourseLessonViewSection>
    );
};
